import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';

interface IProps {
  topText: string;
  bottomText: string;
  fontSize?: number;
}

export const PlayingSongInfo: FunctionComponent<IProps> = ({ bottomText, topText, fontSize = defaultScale(18) }) => {
  function topTextComponent() {
    if (topText) {
      return <Text style={[styles.topText, { fontSize }]}>{topText}</Text>;
    }
  }

  function bottomTextComponent() {
    if (bottomText) {
      return <Text style={[styles.bottomText, { fontSize }]}>{bottomText}</Text>;
    }
  }

  return (
    <View style={{ alignItems: 'center' }}>
      {topTextComponent()}
      {bottomTextComponent()}
    </View>
  );
};

const styles = StyleSheet.create({
  bottomText: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.WHITE,
    paddingBottom: defaultScale(5),
  },
  topText: {
    ...Theme.textStyle.heading2,
    color: Theme.GREY,
    fontFamily: Theme.Custom400,
  },
});
